<div class="container-fluid">
  <app-pagetitle title="Escalation" [breadcrumbItems]="breadCrumbItems"></app-pagetitle>

  <div class="row">
    <div class="col-lg-12">
      <div class="card">
        <div class="card-body">
          <div class="row d-flex justify-content-between mb-2">
            <a class="btn btn-success" (click)="openAddModal(content)">
              <i class="mdi mdi-plus mr-2"></i> Add Escalation
            </a>
            <div>
              <input type="text" class="form-control" placeholder="Search..." [(ngModel)]="searchTerm" />
            </div>
          </div>

          <div class="table-responsive mt-3">
            <table class="table table-striped table-bordered table-centered nowrap" style="width: 100%">
              <thead class="thead-dark">
                <tr>
                  <th>Department</th>
                  <th>Machine Id</th>
                  <th>Machine Name</th>
                  <th>Parameter</th>
                  <th>Alert</th>
                  <th>Alert Occurrence</th>
                  <th>Alert Duration</th>
                  <th>Interlock</th>
                  <th>Duration</th>
                  <th>Upper Limit</th>
                  <th>Lower Limit</th>
                  <th style="width: 120px">Action</th>
                </tr>
              </thead>
              <tbody>

                <tr *ngFor="
                    let item of data
                      | filter: searchTerm
                      | slice: pageSize
                      | slice: 0 : itemsPerPage;
                    let i = index
                  ">
                  <td>{{ item.departmentName }}</td>
                  <td>{{ item.deviceId }}</td>
                  <td>{{ item.deviceName }}</td>
                  <td>{{ item.parameter }}</td>
                  <td>
                    <span class="badge" [ngClass]="
                        item.alert ? 'badge-success' : 'badge-secondary'
                      ">
                      {{ item.alert ? "Yes" : "No" }}
                    </span>
                  </td>
                  <td>{{ item.alert ? item.alertOccurence : "—" }}</td>
                   <td>
                    {{ item.alert ? item.alertDuration : "—" }}
                  </td>
                  <td>
                    <span class="badge" [ngClass]="
                        item.isInterlock ? 'badge-warning' : 'badge-secondary'
                      ">
                      {{ item.isInterlock ? "Yes" : "No" }}
                    </span>
                  </td>
                 
                  <td>{{ item.isInterlock ? item.interlockDuration : "—" }}</td>
                  <td>{{ item.upperLimit }}</td>
                  <td>{{ item.lowerLimit }}</td>
                  <td>
                    <a class="mr-3 text-primary" title="Edit" style="cursor: pointer"
                      (click)="openEditModal(item, i, content)">
                      <i class="mdi mdi-pencil font-size-18"></i>
                    </a>
                    <a class="text-danger" title="Delete" style="cursor: pointer"
                      (click)="openDeleteModal(item, i, deletetemp)">
                      <i class="mdi mdi-trash-can font-size-18"></i>
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="mt-3" *ngIf="data.length > itemsPerPage">
              <ngb-pagination class="pagination-rounded" [collectionSize]="(data | filter: searchTerm).length"
                [pageSize]="itemsPerPage" [(page)]="currentPage" [maxSize]="5" [rotate]="true" [ellipses]="true"
                [boundaryLinks]="true" (pageChange)="onPageChange($event)">
              </ngb-pagination>
            </div>
          </div>

          <div class="card p-3" *ngIf="data.length === 0">
            <span *ngIf="errmsg === ''"><strong>No Escalation Found. Please Add Escalation.</strong></span>
            <span *ngIf="errmsg !== ''"><strong>{{ errmsg }}</strong></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #content let-modal>
  <div class="modal-header">
    <h5 class="modal-title">{{ isEditMode ? "Edit" : "Add" }} Escalation</h5>
    <button type="button" class="close" (click)="modal.dismiss()">
      <span>&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="row">
      <div class="col-md-6 form-group">
        <label>Department <span class="text-danger">*</span></label>
        <select class="form-control form-control-sm" [(ngModel)]="formModel.departmentName"
          (change)="onDepartmentChange(formModel.departmentName)" [ngClass]="{ 'is-invalid': formErrors.departmentName }">
          <option value="">-- Select Department --</option>
          <option *ngFor="let dept of departmentData" [value]="dept.departmentName">
            {{ dept.departmentName }}
          </option>
        </select>
        <div class="invalid-feedback">{{ formErrors.departmentName }}</div>
      </div>

      <div class="col-md-6 form-group">
        <label>Machine Name <span class="text-danger">*</span></label>
        <select class="form-control form-control-sm" [(ngModel)]="formModel.deviceName"
          (change)="onDeviceChange(formModel.deviceName)" [ngClass]="{ 'is-invalid': formErrors.deviceName }">
          <option value="">-- Select Machine --</option>
          <option *ngFor="let device of devicelistData" [value]="device.deviceName">
            {{ device.deviceName }}
          </option>
        </select>
        <div class="invalid-feedback">{{ formErrors.deviceName }}</div>
      </div>

      <div class="col-md-6 form-group">
        <label>Parameter <span class="text-danger">*</span></label>
        <select class="form-control form-control-sm" [(ngModel)]="formModel.parameter"
          [ngClass]="{ 'is-invalid': formErrors.parameter }">
          <option value="">-- Select Parameter --</option>
          <option *ngFor="let param of parameterList" [value]="param">
            {{ param }}
          </option>
        </select>
        <div class="invalid-feedback">{{ formErrors.parameter }}</div>
      </div>

      <div class="col-md-3 form-group">
        <label>Upper Limit <span class="text-danger">*</span></label>
        <input type="number" class="form-control form-control-sm" [(ngModel)]="formModel.upperLimit"
          placeholder="e.g. 100" [ngClass]="{ 'is-invalid': formErrors.upperLimit }" />
        <div class="invalid-feedback">{{ formErrors.upperLimit }}</div>
      </div>

      <div class="col-md-3 form-group">
        <label>Lower Limit <span class="text-danger">*</span></label>
        <input type="number" class="form-control form-control-sm" [(ngModel)]="formModel.lowerLimit"
          placeholder="e.g. 10" [ngClass]="{ 'is-invalid': formErrors.lowerLimit }" />
        <div class="invalid-feedback">{{ formErrors.lowerLimit }}</div>
      </div>

      <div class="col-md-12 mt-1 mb-2">
        <div class="d-flex align-items-center p-2 rounded" style="background: #f8f9fa; border-left: 3px solid #28a745">
          <div class="custom-control custom-switch mb-0">
            <input type="checkbox" class="custom-control-input" id="alertSwitch" [(ngModel)]="formModel.alert"
              (change)="onAlertToggle()" />
            <label class="custom-control-label font-weight-bold" for="alertSwitch">
              Enable Alert
            </label>
          </div>
        </div>
      </div>

      <div class="col-md-3 form-group" *ngIf="formModel.alert">
        <label>Alert Occurrence <span class="text-danger">*</span></label>
        <input type="number" class="form-control form-control-sm" [(ngModel)]="formModel.alertOccurence" min="1" max="5"
          placeholder="e.g. 2" [ngClass]="{ 'is-invalid': formErrors.alertOccurence }" />
        <div class="invalid-feedback">{{ formErrors.alertOccurence }}</div>
      </div>
         <div class="col-md-3 form-group" *ngIf="formModel.alert">
          <label>Duration (sec) <span class="text-danger">*</span></label>
          <input type="number" class="form-control form-control-sm" [(ngModel)]="formModel.alertDuration" min="1"
            placeholder="e.g. 30" [ngClass]="{ 'is-invalid': formErrors.alertDuration }" />
          <div class="invalid-feedback">{{ formErrors.alertDuration }}</div>
        </div>
        <div class="col-md-3 form-group" *ngIf="formModel.alert">
          <label>Alert Message <span class="text-danger">*</span></label>
          <textarea type="text" class="form-control form-control-sm" minlength="1" maxlength="30" required [(ngModel)]="formModel.alertmsg" min="1"
            placeholder="e.g. abc" [ngClass]="{ 'is-invalid': formErrors.alertmsg }" ></textarea>
          <div class="invalid-feedback">{{ formErrors.alertmsg }}</div>
        </div>

      <div class="col-md-12 mt-1 mb-2">
        <div class="d-flex align-items-center p-2 rounded" style="background: #f8f9fa; border-left: 3px solid #ffc107">
          <div class="custom-control custom-switch mb-0">
            <input type="checkbox" class="custom-control-input" id="interlockSwitch" [(ngModel)]="formModel.isInterlock"
              (change)="onInterlockToggle()" />
            <label class="custom-control-label font-weight-bold" for="interlockSwitch">
              Enable Interlock
            </label>
          </div>
        </div>
      </div>

      <ng-container *ngIf="formModel.isInterlock">
        <div class="col-md-6 form-group">
          <label>Interlock Duration (Sec)<span class="text-danger">*</span></label>
          <input type="number" class="form-control form-control-sm" [(ngModel)]="formModel.interlockDuration" min="1"
            placeholder="e.g. 1" [ngClass]="{ 'is-invalid': formErrors.interlockDuration }" />
          <div class="invalid-feedback">
            {{ formErrors.interlockDuration }}
          </div>
        </div>

     
      </ng-container>
    </div>
  </div>

  <div class="modal-footer py-2">
    <button type="button" class="btn btn-sm btn-secondary" (click)="modal.dismiss(); resetForm()">
      Cancel
    </button>
    <button type="button" class="btn btn-sm btn-primary" (click)="onSubmit(modal)">
      {{ isEditMode ? "Update" : "Save" }}
    </button>
  </div>
</ng-template>

<ng-template #deletetemp role="document" let-modal="close">
  <div class="modal-header">
    <h5 class="modal-title">Delete Escalation</h5>
    <button type="button" class="close" aria-label="Close" (click)="modal('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body card-body">
    <div class="example-container">
      <form>
        <div>
          <p>Are you sure to Delete?</p>
        </div>
        <button type="submit" class="btn btn-danger round waves-effect headr" (click)="confirmDelete(modal)">
          Delete
        </button>
        &nbsp;
        <button type="submit" class="btn btn-info round waves-effect headr" (click)="modal('Cross click')">
          Cancel
        </button>
      </form>
    </div>
  </div>
</ng-template>